import type { IxmUserauthV1RealmKeys } from '@interxfi/types';
import { type EntityPathBuilder, getResolvedPath } from '../../../util/routing/entity-paths';

export const USERAUTH_REALM_BASE_PATH = getResolvedPath('/realm');

export const getUserauthRealmPath: EntityPathBuilder<IxmUserauthV1RealmKeys> = (context) => {
  switch (context.kind) {
    case 'list':
      return USERAUTH_REALM_BASE_PATH;
    case 'detail': {
      if (!context?.keys?.realmId) {
        return undefined;
      }

      return getResolvedPath(`${USERAUTH_REALM_BASE_PATH}/$realmId`, context.keys);
    }
  }
};

export function getUserauthRealmDetailPath(realmId: string | undefined) {
  if (!realmId) {
    return undefined;
  }

  return getUserauthRealmPath({ kind: 'detail', keys: { realmId } });
}
